import React, { useEffect, useMemo, useState } from 'react'
import './style.scss'

import GuestBaseLayout from 'general/components/eInvoiceComponents/BaseLayout/GuestBaseLayout'
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom'
import invoiceApi from 'api/invoiceApi'
import Utils, {
  formatDateByFormat,
  viewPopupSettingTool,
} from 'general/utils/Utils'
import moment from 'moment'
import invoiceReportApi from 'api/invoiceReportApi'
import { useDispatch } from 'react-redux'
import { setAppSpinning } from 'app/appSlice'
import ToastHelper from 'general/helpers/ToastHelper'
import toolApi from 'api/toolApi'
import customProtocolCheck from 'custom-protocol-check'
import wsHelperInstance from 'general/helpers/WebSocketHelper'
import Global from 'general/utils/Global'
import {
  INVOICE_TYPE,
  MAX_WAIT_SIGN_INVOICE,
  TICKET_STATUS,
} from 'general/constants/AppConstants'
import ModalConnectConfig from 'features/System/components/Modals/ModalConnectConfig'
import ModalChooseSignMethod from './components/ModalChooseSignMethod'
import ModalSignatureInfo from 'features/RegistrationAccountingDocument/screens/CreateRegistration/components'

const reportTypeToVnese = (reportType) => {
  return reportType == TICKET_STATUS.REPLACE ? 'thay thế' : 'điều chỉnh'
}

function GuestSignInvoiceReport() {
  const dispatch = useDispatch()
  const { invoiceId } = useParams()
  const { pathname } = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()

  const jwtToken = searchParams.get('jwtToken')

  const _reportType = useMemo(
    () => pathname?.split('/')?.at(1),
    [pathname],
  ) /* bien-ban-huy/bien-ban-dieu-chinh */
  let reportType = useMemo(
    () =>
      _reportType == 'bien-ban-thay-the'
        ? TICKET_STATUS.REPLACE
        : _reportType == 'bien-ban-dieu-chinh'
          ? TICKET_STATUS.ADJUST
          : '',
    [_reportType],
  )

  const [invoice, setInvoice] = useState()
  const [reportStatus, setReportStatus] = useState()
  const [showModalConnectConfig, setShowModalConnectConfig] = useState(false)
  const [showModalChooseSignMethod, setShowModalChooseSignMethod] =
    useState(false)
  const [showModalConnectConfigInvofor, setShowModalConnectConfigInvofor] =
    useState({ show: false })

  const report = useMemo(() => invoice?.report, [invoice])

  useEffect(() => {
    fetchInvoiceData(invoiceId)
  }, [invoiceId, jwtToken])

  useEffect(() => {
    if (!invoice) return

    if (invoice.reportType && invoice.reportType != reportType) {
      ToastHelper.showError(
        `Không thể lập biên bản ${reportTypeToVnese(
          reportType,
        )} khi hóa đơn đã có biên bản ${reportTypeToVnese(invoice.reportType)}`,
      )
      navigate('/hoa-don-dau-ra/hoa-don/danh-sach-hoa-don')
    }
  }, [invoice])

  const fetchInvoiceData = async (invoiceId) => {
    try {
      const res = await invoiceApi.findById(invoiceId, jwtToken)

      if (res?.result === 'success') {
        setInvoice(res?.data)
      } else {
        ToastHelper.showError('Không tìm thấy dữ liệu')
        // navigate('/hoa-don-dau-ra/hoa-don/danh-sach-hoa-don')
      }
    } catch (err) {
      ToastHelper.showError('Có lỗi khi tìm dữ liệu')
      // navigate('/hoa-don-dau-ra/hoa-don/danh-sach-hoa-don')
    }
  }

  const previewCancellationReport = async (reportId) => {
    dispatch(setAppSpinning(true))
    try {
      let res = await invoiceReportApi.preview({
        reportId,
        jwtToken,
      })
      dispatch(setAppSpinning(false))

      let _newFile = new File(
        [res],
        `Biên bản ${reportTypeToVnese(reportType)}.pdf`,
        {
          type: 'application/pdf',
        },
      )
      var _fileURL = URL.createObjectURL(_newFile)
      window.open(_fileURL, '_blank')
    } catch (e) {
      console.log(e)
      dispatch(setAppSpinning(false))
    }
  }

  const customerSignCancellationReport = async () => {
    try {
      const { url } = await toolApi.genToolUrl({
        param2: 'signReport',
        jwtToken,
      })
      console.log('invoice', invoice)
      setReportStatus(invoice?.reportStatus)
      if (url) {
        let notInstalledCb = () => {
          // alert('Chua cai tool!')
          viewPopupSettingTool()
        }

        customProtocolCheck(
          url,
          notInstalledCb,
          () => {
            Utils.openInCurrentTab(url)
          },
          2500,
        )

        if (reportType == TICKET_STATUS.REPLACE) {
          wsHelperInstance.onExecutingSignCancellationReport(
            report.reportId,
            url
              .replace(process.env.REACT_APP_BASE_URL_SCHEMA, '')
              .split(',')
              ?.at(0),
          )
        } else {
          wsHelperInstance.onExecutingSignAdjustReport(
            report.reportId,
            url
              .replace(process.env.REACT_APP_BASE_URL_SCHEMA, '')
              .split(',')
              ?.at(0),
          )
        }

        Global.gExecutingSignInvoiceReportTimeOut = setTimeout(() => {
          dispatch(setAppSpinning(false))
        }, MAX_WAIT_SIGN_INVOICE)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const handleApplyHSM = async (values) => {
    try {
      dispatch(setAppSpinning(true))
      await invoiceReportApi.hsmReportSign({
        reportId: report.reportId,
        hsmAgreementUUID: values.agreementUUID,
        hsmPasscode: values.passcode,
        jwtToken,
      })
      dispatch(setAppSpinning(false))

      navigate(`/bien-ban-thay-the/ky/${invoiceId}?jwtToken=${jwtToken}`)
    } catch (e) {
      console.log(e)
      dispatch(setAppSpinning(false))
    }
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (reportStatus && reportStatus !== 5) {
        ;(async () => {
          try {
            const res = await invoiceApi.findById(invoiceId, jwtToken)
            if (res?.result === 'success') {
              if (res?.data?.reportType != 'ADJUST') {
                if (res?.data?.reportStatus == 5) {
                  setInvoice(res?.data)
                  ToastHelper.showSuccess('Ký biên bản thành công')
                  setShowModalChooseSignMethod(false)
                  location.reload()
                }
              } else {
                if (res?.data?.report?.reportStatus == 5) {
                  setInvoice(res?.data)
                  ToastHelper.showSuccess('Ký biên bản thành công')
                  setShowModalChooseSignMethod(false)
                  location.reload()
                }
              }
            } else {
              // handle lỗi khác nếu cần
            }
          } catch (err) {
            console.error('Lỗi gọi API:', err)
          }
        })()
      }
    }, 1500)

    return () => clearInterval(intervalId)
  }, [reportStatus, invoiceId, jwtToken])

  return (
    <GuestBaseLayout nonPadding={true}>
      <div
        className="GuestSignInvoiceReport pt-5"
        style={{ backgroundColor: '#f0f2f5' }}
      >
        <div
          className="invoice-report-container mb-5"
          style={{ maxHeight: '80vh', overflow: 'auto' }}
        >
          <div className="invoice-report-paper mx-auto">
            <div classN ame="d-flex flex-column justify-content-center">
              <div className="text-center pt-5">
                <div
                  className="text-uppercase font-sfpro-bold"
                  style={{ fontSize: '20px', fontWeight: '400' }}
                >
                  CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
                </div>

                <div
                  className="font-sfpro-bold"
                  style={{ fontSize: '16px', fontWeight: '400' }}
                >
                  Độc lập - Tự do - Hạnh phúc
                </div>
                <div
                  className="font-sfpro-bold"
                  style={{
                    fontSize: '20px',
                    fontWeight: '700',
                    marginTop: '30px',
                  }}
                >
                  {`BIÊN BẢN ${reportTypeToVnese(
                    reportType,
                  ).toUpperCase()} HÓA ĐƠN`}
                </div>
              </div>
            </div>

            <div
              className="d-flex align-items-end justify-content-center"
              style={{ minHeight: '44px', paddingBottom: '8px' }}
            >
              <div className="invoice-report-label">Số biên bản:</div>
              <div>
                <input
                  type="text"
                  className="form-control input-dot"
                  readOnly={/* screenAction == 'xem' */ true}
                  value={report?.no}
                  required
                />
              </div>
            </div>

            <div
              className=" mt-5 "
              style={{ minHeight: '44px', paddingBottom: '8px' }}
            >
              {/* <div className="invoice-report-label">
                - Căn cứ Nghị định 123/2020/NĐ-CP ngày 19/10/2020 của Chính phủ
                quy định về hóa đơn, chứng từ.
              </div>
              <div className="invoice-report-label">
                - Căn cứ Nghị định 70/2025/NĐ-CP ngày 20/03/2025 của Chính phủ
                sửa đổi, bổ sung một số điều của Nghị đinh 123/2020/NĐ-CP ngày
                19/10/2020 của Chính phủ quy định về hóa đơn, chứng từ.
              </div>{' '}
              <div className="invoice-report-label">
                - Căn cứ Thông tư 32/2025/TT-BTC ngày 31/05/2025 của Bộ Tài
                chính hướng dẫn thực hiện Nghị định số 123/2020/NĐ-CP ngày
                19/10/2020 của Chính phủ quy định về hóa đơn, chứng từ, Nghị
                định số 70/NĐ-CP/2025 ngày 20/03/2025 sửa đổi, bổ sung một số
                điều Nghị định số 123/2020/NĐ-CP.
              </div>{' '}
              <div className="invoice-report-label">
                - Căn cứ vào thỏa thuận giữa các bên.
              </div> */}
              <div className="invoice-report-label">
                - Căn cứ Luật Quản lý thuế số 108/2025/QH15 ngày 10 tháng 12 năm
                2025;
              </div>
              <div className="invoice-report-label">
                - Căn cứ Nghị định 254/2026/NĐ-CP ngày 30 tháng 06 năm 2026 quy
                định chi tiết một số điều và biện pháp để tổ chức, hướng dẫn thi
                hành Luật Quản lý thuế số 108/2025/QH15 về hóa đơn điện tử,
                chứng từ điện tử;
              </div>
              <div className="invoice-report-label">
                - Căn cứ Thông tư số 91/2026/TT-BTC ngày 30 tháng 6 năm 2026 quy
                định một số điều của Luật quản lý thuế và Nghị định số
                254/2026/NĐ-CP của Chính phủ quy định chi tiết một số điều và
                biện pháp để tổ chức, hướng dẫn thi hành Luật Quản lý thuế số
                108/2025/QH15 về hóa đơn điện tử, chứng từ điện tử.
              </div>
            </div>

            <div
              className="d-flex align-items-end"
              style={{ minHeight: '44px', paddingBottom: '8px' }}
            >
              <div className="d-flex justify-content-center">
                <span className="invoice-date">
                  Hôm nay, ngày {moment(report?.date, 'YYYY-MM-DD').date()}{' '}
                  tháng {moment(report?.date, 'YYYY-MM-DD').month() + 1} năm{' '}
                  {moment(report?.date, 'YYYY-MM-DD').year()} chúng tôi gồm có:
                </span>
              </div>
            </div>

            <div
              className="d-flex align-items-end"
              style={{ minHeight: '44px', paddingBottom: '8px' }}
            >
              <div className="invoice-report-label-bold">Bên A (Bên bán): </div>
              <div className="" style={{ flexBasis: 'auto' }}>
                {report?.sellerName}
              </div>
            </div>

            <div
              className="d-flex align-items-end"
              style={{ minHeight: '44px', paddingBottom: '8px' }}
            >
              <div className="invoice-report-label">Địa chỉ: </div>
              <div className="" style={{ flexBasis: 'auto' }}>
                {report?.sellerFullAddress}
              </div>
            </div>

            <div className="d-flex flex-row justify-content-between">
              <div
                className="d-flex align-items-end"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="invoice-report-label">Mã số thuế: </div>
                <div className="" style={{ flexBasis: 'auto' }}>
                  {report?.sellerTaxCode}
                </div>
              </div>
              <div
                className="d-flex align-items-end"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="invoice-report-label">Số điện thoại: </div>
                <div className="" style={{ flexBasis: 'auto' }}>
                  <input
                    type="text"
                    className="form-control input-dot"
                    style={{ flex: 'auto' }}
                    value={report?.sellerPhone}
                    readOnly={/* screenAction == 'xem' */ true}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex flex-row justify-content-between">
              <div
                className="d-flex align-items-end"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="invoice-report-label">Đại diện: </div>
                <div className="" style={{ flexBasis: 'auto' }}>
                  <input
                    type="text"
                    className="form-control input-dot"
                    style={{ flex: 'auto' }}
                    value={report?.sellerContactPersonName}
                    readOnly={/* screenAction == 'xem' */ true}
                  />
                </div>
              </div>

              <div
                className="d-flex align-items-end"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="invoice-report-label">Chức vụ: </div>
                <div className="" style={{ flexBasis: 'auto' }}>
                  <input
                    type="text"
                    className="form-control input-dot"
                    style={{ flex: 'auto' }}
                    value={report?.sellerContactPersonPosition}
                    readOnly={/* screenAction == 'xem' */ true}
                  />
                </div>
              </div>
            </div>

            <div
              className="d-flex align-items-end"
              style={{ minHeight: '44px', paddingBottom: '8px' }}
            >
              <div className="invoice-report-label-bold">Bên B (Bên mua): </div>
              <div className="flex-grow-1" style={{ flexBasis: 'auto' }}>
                <input
                  type="text"
                  className="form-control input-dot"
                  style={{ flex: 'auto' }}
                  value={report?.customerName}
                  readOnly={/* screenAction == 'xem' */ true}
                />
              </div>
            </div>

            <div
              className="d-flex align-items-end"
              style={{ minHeight: '44px', paddingBottom: '8px' }}
            >
              <div className="invoice-report-label">Địa chỉ: </div>
              <div className="flex-grow-1" style={{ flexBasis: 'auto' }}>
                <input
                  type="text"
                  className="form-control input-dot w-100"
                  style={{ flex: 'auto' }}
                  value={report?.customerFullAddress}
                  readOnly={/* screenAction == 'xem' */ true}
                />
              </div>
            </div>

            <div className="d-flex flex-row justify-content-between">
              <div
                className="d-flex align-items-end"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="invoice-report-label">Mã số thuế: </div>
                <div className="" style={{ flexBasis: 'auto' }}>
                  <input
                    type="text"
                    className="form-control input-dot"
                    style={{ flex: 'auto' }}
                    value={report?.customerTaxCode}
                    readOnly={/* screenAction == 'xem' */ true}
                  />
                </div>
              </div>
              <div
                className="d-flex align-items-end"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="invoice-report-label">Số điện thoại: </div>
                <div className="" style={{ flexBasis: 'auto' }}>
                  <input
                    type="text"
                    className="form-control input-dot"
                    style={{ flex: 'auto' }}
                    value={report?.customerPhone}
                    readOnly={/* screenAction == 'xem' */ true}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex flex-row justify-content-between">
              <div
                className="d-flex align-items-end"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="invoice-report-label">Đại diện: </div>
                <div className="" style={{ flexBasis: 'auto' }}>
                  <input
                    type="text"
                    className="form-control input-dot"
                    style={{ flex: 'auto' }}
                    value={report?.customerContactPersonName}
                    readOnly={/* screenAction == 'xem' */ true}
                  />
                </div>
              </div>

              <div
                className="d-flex align-items-end"
                style={{ minHeight: '44px', paddingBottom: '8px' }}
              >
                <div className="invoice-report-label">Chức vụ: </div>
                <div className="" style={{ flexBasis: 'auto' }}>
                  <input
                    type="text"
                    className="form-control input-dot"
                    style={{ flex: 'auto' }}
                    value={report?.customerContactPersonPosition}
                    readOnly={/* screenAction == 'xem' */ true}
                  />
                </div>
              </div>
            </div>

            <div
              className="d-flex align-items-end"
              style={{ minHeight: '44px', paddingBottom: '8px' }}
            >
              <div className="invoice-report-label">
                {`Hai bên thống nhất lập biên bản này để ${reportTypeToVnese(
                  reportType,
                )} hóa đơn theo quy
                định.`}
              </div>
            </div>

            <div
              className="d-flex align-items-end"
              style={{ minHeight: '44px', paddingBottom: '8px' }}
            >
              <div className="invoice-report-label">{`Hóa đơn bị ${reportTypeToVnese(
                reportType,
              )}: `}</div>
              <div className="" style={{ flexBasis: 'auto' }}>
                {invoice?.reportType == 'ADJUST' ? (
                  <div className="invoice-report-label">
                    Ký hiệu {invoice?.Original?.serial ?? invoice?.serial}, số{' '}
                    {Utils.padString(
                      invoice?.Original?.no ?? invoice?.no,
                      8,
                      '0',
                    )}
                    , ngày{' '}
                    {formatDateByFormat(
                      invoice?.Original?.date ?? invoice?.date,
                    )}
                  </div>
                ) : (
                  <div className="invoice-report-label">
                    Ký hiệu {invoice?.serial}, số{' '}
                    {Utils.padString(invoice?.no, 8, '0')}, ngày{' '}
                    {formatDateByFormat(invoice?.date)}
                  </div>
                )}
              </div>
            </div>

            <div
              className="d-flex align-items-end"
              style={{ minHeight: '44px', paddingBottom: '8px' }}
            >
              <div className="invoice-report-label">{`Lý do ${reportTypeToVnese(
                reportType,
              )}: `}</div>
              <div className="flex-grow-1">
                <input
                  type="text"
                  className="form-control input-dot"
                  value={report?.reason}
                  readOnly={/* screenAction == 'xem' */ true}
                />
              </div>
            </div>

            <div
              className="d-flex align-items-end"
              style={{ minHeight: '44px', paddingBottom: '8px' }}
            >
              Chúng tôi xin cam đoan các thông tin khai ở trên là hoàn toàn
              chính xác. Nếu có bất kỳ sai sót nào chúng tôi xin chịu trách
              nhiệm trước pháp luật.
            </div>

            <div className="d-flex flex-row justify-content-between align-items-start px-30 mb-5">
              <div className="text-center">
                <div>
                  <div className="font-sfpro-bold">Đại diện bên A</div>
                  <div className="mb-4">(Chữ ký số, chữ ký điện)</div>
                  <button
                    className="btn btn-light d-inline-flex align-items-center"
                    style={{ color: '#041847', backgroundColor: '#e4e6eb' }}
                    disabled={true}
                  >
                    <i
                      className="fal fa-file-contract"
                      style={{ color: '#041847' }}
                    ></i>
                    Ký điện tử
                  </button>
                </div>
              </div>
              {invoice?.report?.customerTaxCode && (
                <div className="text-center">
                  <div>
                    <div className="font-sfpro-bold">Đại diện bên B</div>
                    <div className="mb-4">(Chữ ký số, chữ ký điện)</div>
                    {([4, 5].includes(invoice?.reportStatus) ||
                      ([4, 5].includes(invoice?.report?.reportStatus) &&
                        invoice?.report?.reportType == 'ADJUST')) &&
                      invoice?.customerTaxCode && (
                        <button
                          className="btn btn-light d-inline-flex align-items-center"
                          style={{
                            color: '#041847',
                            backgroundColor: '#e4e6eb',
                          }}
                          disabled={
                            ![4].includes(
                              invoice?.report?.reportType == 'ADJUST'
                                ? invoice?.report?.reportStatus
                                : invoice?.reportStatus,
                            )
                          }
                          onClick={() => {
                            setShowModalChooseSignMethod(true)
                          }}
                        >
                          <i
                            className="fal fa-file-contract"
                            style={{ color: '#041847' }}
                          ></i>
                          Ký điện tử
                        </button>
                      )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="d-flex flex-row justify-content-center align-items-center mb-5">
          <button
            className="btn btn-primary"
            onClick={() => previewCancellationReport(report?.reportId)}
          >
            Tải xuống
          </button>
        </div>
      </div>

      <ModalConnectConfig
        title={'Kết nối HSM'}
        description={'Thiết lập kết nối HSM để ký số'}
        method={'HSM'}
        open={showModalConnectConfig}
        onOpenChange={setShowModalConnectConfig}
        onApply={handleApplyHSM}
      />

      <ModalChooseSignMethod
        show={showModalChooseSignMethod}
        setShow={setShowModalChooseSignMethod}
        header={'Chọn phương thức ký số'}
        content={'Vui lòng chọn phương thức ký số'}
        handleChooseUSBToken={customerSignCancellationReport}
        handleChooseHSM={() => {
          setShowModalChooseSignMethod(false)
          setShowModalConnectConfig(true)
        }}
        handleChooseManually={() => {
          setShowModalChooseSignMethod(false)
          setShowModalConnectConfigInvofor({ show: true })
        }}
        closeNTC={1}
      />

      <ModalSignatureInfo
        open={showModalConnectConfigInvofor.show}
        onOpenChange={(state) => {
          setShowModalConnectConfigInvofor({ show: state })
        }}
        onApply={(data) => {
          setShowModalConnectConfigInvofor({ show: false, data })
          console.log('data', data)
        }}
      />
    </GuestBaseLayout>
  )
}

export default GuestSignInvoiceReport
